import React from 'react';
import PropTypes from 'prop-types';

import { LoaderSmall } from './components/LoaderSmall';

import { FlexboxBlock } from './styled';

const Loader = ({ type, color, size }) => {
  if (type === 'small') {
    return (
      <FlexboxBlock fullHeight>
        <LoaderSmall color={color} size={size} />
      </FlexboxBlock>
    );
  }

  /// Стили в App.css
  return (
    <FlexboxBlock>
      <div id="nest2"></div>
    </FlexboxBlock>
  );
};

Loader.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
};

Loader.defaultProps = {
  type: 'default',
  color: '#fff',
  size: '30px',
};

export { Loader };
